import { ContentPromotionActions } from './parts/ContentPromotionActions/ContentPromotionActions';
import { ContentPromotionDetails } from './parts/ContentPromotionDetails/ContentPromotionDetails';
import { ContentPromotionTitle } from './parts/ContentPromotionTitle/ContentPromotionTitle';
import { ContentPromotionBox } from './styles';
import { ContentPromotionProps } from './types';

export const ContentPromotion: React.FC<ContentPromotionProps> = ({
    directCompanies,
    isLoading,
    isAuthorized,
}) => (
    <ContentPromotionBox>
        <ContentPromotionTitle />
        <ContentPromotionDetails directCompanies={directCompanies} isLoading={isLoading} />
        <ContentPromotionActions
            directCompanies={directCompanies}
            isLoading={isLoading}
            isAuthorized={isAuthorized}
        />
    </ContentPromotionBox>
);
